var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScene2FormSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 281.25,
    viewBox: "0 0 132.29 74.414",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "create-form",
    transform: "matrix(.70922 0 0 .70922 -90.064 -56.711)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.16,
    y: 103.32,
    width: 37.042,
    height: 58.208,
    rx: 1.052,
    ry: 1.052,
    fill: "none",
    stroke: "#aa9de2",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "table",
    transform: "matrix(.9 0 0 .9 28.834 3.8906)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.3439,
    y: 15.199,
    width: 105.57,
    height: 43.639,
    rx: 1.3066,
    ry: 1.3066,
    fill: "none",
    stroke: "#aa9de2",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25889
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScene2FormSubmit);
export default __webpack_public_path__ + "static/media/scene2-form-submit.f8ed366d889460b4f7a37e9017ae4346.svg";
export { ForwardRef as ReactComponent };